import App from "@/App.vue";

export default [
  {
    path: "/tribunais",
    name: "court",
    component: App,
    redirect: { name: "list court" },
    children: [
      {
        path: "",
        name: "list court",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ListCourt.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Tribunais",
              disabled: false,
              link: false,
              to: { name: "court" }
            }
          ],
          displayName: "Lista Tribunais - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_tribunal"
        }
      },
      {
        path: "novo-tribunal",
        name: "new court",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCourt.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Adicionar Tribunal",
              disabled: false,
              link: true,
              to: { name: "court" }
            }
          ],
          displayName: "Adicionar Tribunal - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_tribunal"
        }
      },
      {
        path: ":tribunal/varas",
        name: "list region court",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ListRegionCourt.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Varas do Tribunal",
              disabled: false,
              link: true,
              to: { name: "court" }
            }
          ],
          displayName: "Lista Varas - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_tribunal"
        }
      },
      {
        path: ":tribunal/editar-tribunal",
        name: "edit court",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditCourt.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Tribunais",
              disabled: false,
              link: true,
              to: { name: "court" }
            }
          ],
          displayName: "Editar Tribunal - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_tribunal"
        }
      },
      {
        path: ":tribunal/nova-vara",
        name: "new region court",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/RegionCourt.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Tribunais",
              disabled: false,
              link: true,
              to: { name: "court" }
            }
          ],
          displayName: "Nova Vara - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_tribunal"
        }
      },
      {
        path: ":tribunal/vara/:vara",
        name: "edit region court",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/RegionCourt.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Tribunais",
              disabled: false,
              link: true,
              to: { name: "court" }
            }
          ],
          displayName: "Editar Vara - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_tribunal"
        }
      }
    ]
  }
];
